import { render, staticRenderFns } from "./ChangeDomainsServerContent.vue?vue&type=template&id=c57e545c"
import script from "./ChangeDomainsServerContent.vue?vue&type=script&lang=js"
export * from "./ChangeDomainsServerContent.vue?vue&type=script&lang=js"
import style0 from "./ChangeDomainsServerContent.vue?vue&type=style&index=0&id=c57e545c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports